import ComponentLink from '../domain/component-link';

export default class SearchCO2LinkModel {
	public searchSpinnerVisible: boolean;
	public searchResults: ComponentLink[];
	public searchLabelText: string;
	public searchLabelVariant: 'default' | 'error';
	public constructor() {
		this.searchSpinnerVisible = false;
		this.searchResults = [];
		this.searchLabelText = '';
		this.searchLabelVariant = 'default';
	}
}
